export const GetPraiaGame = (appCode: string) => {
  switch (appCode) {
    case '1':
      return 'Praia Classic';
      break;
    case '2':
      return 'Praia NEW';
      break;
    case '3':
      return 'Both Praia';
      break;
    default:
      return 'Unknown';
  }
};
